export default __webpack_public_path__ + "static/media/footer_map.23a93e29.png";